/**
 * Marketing campaign API helpers (AI IMAGE-header WhatsApp MARKETING).
 * Paths live in endPoints.campaigns — wire a builder page to these helpers.
 */
import apiService from "./apiService";
import { endPoints } from "./endpoints";

const idUrl = (template, id) => template.replace("{{id}}", id);

export const getCreativeDefaults = () =>
    apiService.get(endPoints.campaigns.creativeDefaults);

export const getBrandKit = () => apiService.get(endPoints.campaigns.brandKit);

export const updateBrandKit = (formData) =>
    apiService.put(endPoints.campaigns.brandKit, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });

export const listCampaigns = (query = {}) =>
    apiService.get(endPoints.campaigns.list, {params: query});

export const getCampaign = (id) =>
    apiService.get(idUrl(endPoints.campaigns.detail, id));

export const createCampaign = (formData) =>
    apiService.post(endPoints.campaigns.list, formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });

export const patchCampaign = (id, formData) =>
    apiService.patch(idUrl(endPoints.campaigns.detail, id), formData, {
        headers: { "Content-Type": "multipart/form-data" },
    });

export const deleteCampaign = (id) =>
    apiService.delete(idUrl(endPoints.campaigns.detail, id));

export const cancelCampaign = (id) =>
    apiService.post(idUrl(endPoints.campaigns.cancel, id), {});

export const enhancePrompt = (id, payload = {}) =>
    apiService.post(idUrl(endPoints.campaigns.enhancePrompt, id), payload);

export const generateCampaign = (id, asset = "both", payload = {}) =>
    apiService.post(`${idUrl(endPoints.campaigns.generate, id)}?asset=${asset}`, payload);

export const editCreative = (id, instruction) =>
    apiService.post(idUrl(endPoints.campaigns.creativeEdit, id), { instruction });

export const regenerateCreative = (id) =>
    apiService.post(idUrl(endPoints.campaigns.creativeRegenerate, id), {});

export const downloadCreativeUrl = (id) =>
    idUrl(endPoints.campaigns.creativeDownload, id);

/** Auth-gated download of the current creative as a file blob. */
export const downloadCreative = (id) =>
    apiService.get(idUrl(endPoints.campaigns.creativeDownload, id), {
        responseType: "blob",
    });

/** Newest-first creative history tiles for a campaign. */
export const listCreativeVersions = (id) =>
    apiService.get(idUrl(endPoints.campaigns.creativeVersions, id));

/** Restore a history snapshot (creative + reference + template) onto the campaign. */
export const restoreCreativeVersion = (id, versionId) =>
    apiService.post(
        idUrl(endPoints.campaigns.creativeVersionRestore, id).replace(
            "{{versionId}}",
            versionId
        ),
        {}
    );

export const submitTemplate = (id) =>
    apiService.post(idUrl(endPoints.campaigns.submitTemplate, id), {});

export const setAudience = (id, audience, audienceFile) => {
    const body = new FormData();
    body.append("audience", JSON.stringify(audience));
    if (audienceFile) body.append("audience_file", audienceFile);
    return apiService.post(idUrl(endPoints.campaigns.audience, id), body, {
        headers: { "Content-Type": "multipart/form-data" },
    });
};

export const setRunMode = (id, payload) =>
    apiService.post(idUrl(endPoints.campaigns.runMode, id), payload);

export const runCampaign = (id) =>
    apiService.post(idUrl(endPoints.campaigns.run, id), {});

export const testSend = (id, payload) =>
    apiService.post(idUrl(endPoints.campaigns.testSend, id), payload);

export const getCampaignAnalytics = (id) =>
    apiService.get(idUrl(endPoints.campaigns.analytics, id));

/** Paginated clients who tapped a QUICK_REPLY option. */
export const getCampaignButtonReplies = (id, params = {}) =>
    apiService.get(idUrl(endPoints.campaigns.buttonReplies, id), {params});

/** CSV export of button reply clients (optional button_index). */
export const exportCampaignButtonReplies = (id, params = {}) =>
    apiService.get(idUrl(endPoints.campaigns.buttonRepliesExport, id), {
        params,
        responseType: "blob",
    });

/** Poll async generation job (socket fallback). */
export const getGenerationJob = (jobId) =>
    apiService.get(idUrl(endPoints.campaigns.generationJob, jobId));
